// extracted by mini-css-extract-plugin
export var closeButton = "_k3-1";
export var closeX = "_k3-3";
export var container = "_k3-0";
export var image = "_k3-2";